import { OIDCClient, OIDCTokenSet, OIDCClientError } from './OIDCClient';
import { Cache } from 'infrastructure/utility/Cache';

function waitNextTokenSet(oidcClient: OIDCClient): Promise<OIDCTokenSet> {
    return new Promise<OIDCTokenSet>(resolve => {
        if (oidcClient.tokenSet) {
            resolve(oidcClient.tokenSet);
            return;
        }

        const listener = () => {
            if (oidcClient.tokenSet) {
                resolve(oidcClient.tokenSet);
            }

            oidcClient.removeTokenSetListener(listener);
        };

        oidcClient.addTokenSetListener(listener);
    });
}

export type TokenKeeper = (prevToken?: string) => Promise<string>;

export function createTokenKeeper(oidcClient: OIDCClient): TokenKeeper {
    const tokenSetCache = new Cache<OIDCTokenSet>();
    tokenSetCache.update(() => waitNextTokenSet(oidcClient));

    oidcClient.addTokenSetListener(() => {
        const newTokenSet = oidcClient.tokenSet;
        if (!newTokenSet) {
            tokenSetCache.update(() => oidcClient.updateToken());
        } else {
            tokenSetCache.update(async () => newTokenSet);
        }
    });

    return async (prevToken?: string) => {
        const forceUpdate = prevToken ? true : false;

        if (forceUpdate) {
            tokenSetCache.update(() => oidcClient.updateToken());
        }

        try {
            const tokenSet = await tokenSetCache.get();
            return tokenSet.idToken;
        } catch (e) {
            if (e instanceof OIDCClientError) {
                oidcClient.clearTokenSet();
            }
            throw e;
        }
    };
}
